
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'marketplace-storefront-public-ui',
  currentProjectVersion: 'static-1.12077',
  depVersions: {
  "marketplace-storefront-public-ui": "static-1.12077",
  "apollo-dlb": "static-3.86",
  "client-types": "static-1.460",
  "dashboard-client-types": "static-1.345",
  "data-fetching-client": "static-1.9626",
  "foundations-components": "static-1.7834",
  "foundations-components-legacy": "static-1.859",
  "foundations-theming": "static-1.4368",
  "googlemaps-react-wrapper": "static-1.3",
  "graphql": "static-1.81",
  "head-dlb": "static-1.4938",
  "hs-test-utils": "static-1.7968",
  "hub-http-shared-msw-handlers": "static-1.9843",
  "hubspot-dlb": "static-2.1832",
  "hubspot-url-utils": "static-1.4049",
  "HubStyleTokens": "static-2.11414",
  "I18n": "static-7.1611",
  "jasmine-runner": "static-1.6421",
  "marketplace-storefront-base": "static-1.12138",
  "quartz": "static-1.6958",
  "react-dlb": "static-1.78",
  "react-rhumb": "static-1.16618",
  "reactive-variable-buffer-atom": "static-1.2811",
  "reporting-testing-lib": "static-1-jbartola_hubspot-replace-checked-ts.32",
  "settings-ui-lib": "static-1.12473",
  "SharedI18nStrings": "static-1.182",
  "signup-ui-core": "static-1.10391",
  "source-map": "static-1.4",
  "trellis-ecosystem": "static-1.7039",
  "ui-addon-i18n": "static-1.11102",
  "ui-addon-react-router-dom": "static-1.9497",
  "unified-auth": "static-1.428",
  "unified-auth-core-lib": "static-1.709",
  "usage-tracker": "static-1.7290",
  "usage-tracker-core": "static-1.7140",
  "customer-data-property-utils": "static-1.8035",
  "hub-http": "static-1.6173",
  "integrations-lib": "static-1.15951",
  "marketplace-ui-common": "static-1.19517",
  "property-management-iframe": "static-1.12981",
  "quartz-config": "static-1.736",
  "quartz-core": "static-1.6177",
  "quartz-routing": "static-1.388",
  "quick-fetch": "static-1.3876",
  "react": "static-7.185",
  "rpc-client-utils": "static-1.4602",
  "ts-schema": "static-1.4037",
  "ui-universal-auth": "static-1.8914",
  "UIComponents": "static-3.8361",
  "apollo-stack-hubspot": "static-3.84",
  "enviro": "static-4.428",
  "hs-promise-rejection-tracking": "static-1.5489",
  "PortalIdParser": "static-2.388",
  "raven": "static-3.5829",
  "raven-hubspot": "static-1.6136",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.77",
  "metrics-js": "static-1.9542",
  "react-redux": "static-7.70",
  "redux": "static-4.16",
  "styled-components": "static-2.88",
  "bend-plugin-trellis-migration": "static-1.3363",
  "moment": "static-3.26",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3235",
  "quartz-webpack": "static-1.3182",
  "bend-plugin-quartz-routing": "static-1.36",
  "fast-json-stable-stringify": "static-1.4",
  "bend-plugin-foundations-components": "static-1.4103",
  "floating-ui": "static-1.55",
  "foundations-assets": "static-1.4808",
  "foundations-theming-specialty": "static-1.2084",
  "framer-motion": "static-1.71",
  "hs-story-utils": "static-1.9380",
  "react-aria": "static-1.65",
  "react-create-root-preference": "static-1.10",
  "react-select-plus": "static-1.104",
  "react-utils": "static-2.5303",
  "react-virtualized": "static-2.98",
  "StyleGuideUI": "static-3.486",
  "tanstack-table": "static-1.54",
  "trellis-assets": "static-1.1678",
  "ui-fonts": "static-1.676",
  "ui-images": "static-2.1140",
  "bend-plugin-foundations-theming": "static-1.2851",
  "foundations-theming-base": "static-1.3353",
  "stylex": "static-1.32",
  "HeadJS": "static-2.741",
  "hs-test-utils-bend-plugin": "static-1.3079",
  "msw": "static-1.39",
  "testing-library": "static-1.151",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.220",
  "moment-timezone": "static-5.82",
  "jasmine": "static-4.4276",
  "ai-components-ui-library": "static-1.8802",
  "ai-rendering-library": "static-1.9916",
  "chirp-fetch": "static-1.1837",
  "connections-embed-lib": "static-1.903",
  "copilot-toolkit": "static-1.10978",
  "feedback-loader": "static-1.29204",
  "laboratory-lib": "static-3.7110",
  "marketplace-embed": "static-1.21920",
  "marketplace-ui-details": "static-1.9413",
  "marketplace-ui-reviews": "static-1.19473",
  "marketplace-ui-tracking": "static-1.13688",
  "sanitize-text": "static-1.8095",
  "ui-addon-video-player": "static-1.8650",
  "usage-tracker-multi": "static-1.5704",
  "usage-tracker-session-replay": "static-1.4976",
  "wootric-nps": "static-1.6937",
  "quartz-head": "static-1.623",
  "web-vitals": "static-1.4",
  "apollo-link-hub-http": "static-2.4600",
  "immer": "static-1.33",
  "immerable": "static-1.4105",
  "highcharts": "static-8.103",
  "hs-lodash": "static-4.45",
  "reporting-client-types": "static-1.2466",
  "reporting-data": "static-1-jbartola_hubspot-replace-checked-ts.32",
  "cssUtils": "static-1.779",
  "flux-actions": "static-1.331",
  "HubStyle": "static-2.11722",
  "PatternValidationJS": "static-1.437",
  "react-colorpicker": "static-2.10162",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10323",
  "rxjs": "static-5.10",
  "underscore": "static-1.8",
  "usage-tracker-container": "static-1.7280",
  "icons": "static-2.644",
  "marketplace-ui-apps-core": "static-1.18050",
  "storybook-react": "static-1.32",
  "trellis-story-utils": "static-1.4467",
  "foundations-components-test-utils": "static-1.5317",
  "quartz-i18n": "static-1.633",
  "react-input-autosize": "static-2.17",
  "google-sheets-integration-lib": "static-1.82",
  "microsoft-drive-integration-lib": "static-1.194",
  "fsm": "static-1.3684",
  "customer-data-objects": "static-1.7614",
  "property-translator": "static-1.5354",
  "hs-locale-management": "static-1.43",
  "frontend-preferences-client": "static-1.7879",
  "hs-promise-utils": "static-1.5545",
  "hubspot-apollo-client": "static-1.4828",
  "integrations-error-boundary-lib": "static-1.13366",
  "integrations-tracking-lib": "static-1.5550",
  "native-integrations-shared-strings": "static-1.7735",
  "reselect": "static-2.16",
  "sanitize": "static-1.4424",
  "superstore": "static-1.4718",
  "ui-shepherd-react": "static-3.10100",
  "ai-settings-ui-library": "static-1.7804",
  "hub-http-janus": "static-1.827",
  "hubspotter-http": "static-1.4611",
  "immutable-less": "static-1.4601",
  "marketplace-ui-client-types": "static-1.16924",
  "nav-meta": "static-1.29488",
  "react-window": "static-1.13",
  "self-service-api": "static-1.10197",
  "ui-addon-upgrades": "static-9.17913",
  "inbound-db-properties-service-client": "static-1.3800",
  "property-management-common": "static-1.5269",
  "ui-addon-iframeable": "static-1.9006",
  "dispatcher": "static-1.135",
  "general-store": "static-6.20",
  "mobile-manifest-mixins": "static-1.515",
  "module-federation": "static-1.22",
  "quartz-auth": "static-1.633",
  "quartz-test": "static-1.633",
  "quartz-tracking": "static-1.337",
  "history": "static-4.47",
  "react-router-dom": "static-5.26",
  "csstype": "static-1.50",
  "bend-plugin-chirp-manifest": "static-1.12",
  "bender-build-tools": "static-1.3123",
  "inbound-db-meta-service-client": "static-1.3550",
  "persist-promise": "static-1.3659",
  "reference-resolvers": "static-1.8122",
  "transmute": "static-2.85",
  "autolinker": "static-3.11",
  "chatspot-core": "static-1.21040",
  "ContentUtils": "static-1.68210",
  "customer-data-objects-ui-components": "static-1.12977",
  "sassPrefix": "static-1.155",
  "avatar-components": "static-1.2450",
  "customer-data-filters-ui": "static-1.39567",
  "customer-data-reference-ui-components": "static-1.13111",
  "embedded-academy-lib": "static-1.14164",
  "ExportDialog": "static-6.10345",
  "highlight.js": "static-1.78",
  "markdown-it": "static-1.6",
  "reporting-action-components": "static-1.41158",
  "reporting-snowflake": "static-1-jbartola_hubspot-replace-checked-ts.32",
  "reporting-ui-components": "static-2-jbartola_hubspot-replace-checked-ts.32",
  "reporting-visualizations": "static-1-jbartola_hubspot-replace-checked-ts.32",
  "ui-addon-teams": "static-1.21479",
  "magpie-lib": "static-1.5528",
  "navigation-components": "static-1.17851",
  "magpie-types": "static-1.4988",
  "simple-logging-lib": "static-1.3001",
  "ai-studio-lib": "static-1.11445",
  "app-governance-lib": "static-1.1375",
  "developer-experience-shared-components": "static-1.10461",
  "ui-addon-integrations-directory-panel": "static-2.7947",
  "ui-product-approvals": "static-1.27990",
  "ui-tool-access": "static-1.10101",
  "usage-based-billing-components-lib": "static-1.8617",
  "usage-tracker-anonymous": "static-1.5707",
  "usage-tracker-public": "static-1.7101",
  "amplitude-session-replay-browser": "static-1.59",
  "ui-extensibility-client-types": "static-1.3881",
  "hubspot-apollo-cache": "static-1.287",
  "universal-page-editor-lib": "static-1.2964",
  "final-form": "static-1.69",
  "redux-toolkit": "static-1.7",
  "simple-data-table": "static-1.2625",
  "merchandise-lib": "static-1.262",
  "atom": "static-1.5024",
  "purchase-motions-components": "static-1.5791",
  "salesImages": "static-1.524",
  "batch-promise": "static-1.1502",
  "crm-component-utils": "static-1.38938",
  "crm-properties-common-lib": "static-1.5828",
  "customer-data-properties": "static-1.51366",
  "framework-data-schema-resolvers": "static-1.6830",
  "property-value-citations": "static-1.1980",
  "reference-resolvers-lite": "static-1.8046",
  "navigation-messaging": "static-1.7178",
  "hubspotter-http-shared-msw-handlers": "static-1.9841",
  "growth-payments-core": "static-1.25213",
  "react-immutable-proptypes": "static-2.8",
  "reporting-datasets-permissions-lib": "static-1.13517",
  "conversations-skeleton-state": "static-1.7200",
  "crm-message-bus": "static-1.42844",
  "reporting-plugins": "static-1.10207",
  "reporting-reports": "static-1-jbartola_hubspot-replace-checked-ts.32",
  "cms-field-types": "static-1.4763",
  "content-icons-ui": "static-1.2213",
  "customer-data-ui-utilities": "static-1.9778",
  "customer-data-filters-ui-msw-helpers": "static-1.22002",
  "FormUrlGenerator": "static-2.4671",
  "framework-builder-read-service-client": "static-1.3969",
  "framework-data-schema-quick-fetch": "static-1.6735",
  "multi-account-reference-resolvers": "static-1.931",
  "onboarding-tours": "static-1.16502",
  "academy-common-lib": "static-1.13624",
  "content-assistance-lib": "static-1.7675",
  "dashboard-lib": "static-1.81313",
  "file-manager-components": "static-1.23471",
  "getting-started-shared-tasks": "static-1.18348",
  "hubspot-prosemirror": "static-1.18085",
  "hubspot-prosemirror-plugins": "static-1.18077",
  "prosemirror": "static-1.13",
  "rich-text-lib": "static-1.19742",
  "share-with-third-party-component-lib": "static-1.8649",
  "ui-addon-draggable": "static-3.4721",
  "ui-asset-management-lib": "static-1.10957",
  "ui-business-units-lib": "static-1.9000",
  "user-context": "static-1.5053",
  "idb-keyval": "static-1.43",
  "reactive-lib": "static-1.673",
  "nest": "static-1.179",
  "codemirror": "static-5.94",
  "react-codemirror": "static-1.10575",
  "framework-listing-lib": "static-2.28531",
  "fuzzy": "static-1.8",
  "user-configuration-lib": "static-1.30577",
  "apps-service-types": "static-1.3829",
  "oauth-service-types": "static-1.4201",
  "onboarding-scopes": "static-1.6414",
  "onboarding-tours-client": "static-1.4716",
  "platform-infra-nav-components": "static-1.7632",
  "subscription-experience-data-types": "static-1.14842",
  "crm-record-cards-service-types": "static-1.3570",
  "location-customization-utils-lib": "static-1.9089",
  "redux-thunk": "static-2.43",
  "purchase-motions-api": "static-1.5794",
  "signup-constants": "static-1.18746",
  "signup-ui-url-generator": "static-2.7990",
  "trials-service-types": "static-1.3855",
  "card-properties-lib": "static-1.44016",
  "commerce-subscription-lib": "static-1.36947",
  "crm-actions": "static-1.6270",
  "crm-cards-sdk": "static-1.43424",
  "customer-data-properties-shared-msw-handlers": "static-1.9170",
  "customer-data-tracking": "static-1.6837",
  "hs-resources": "static-1.96",
  "pulse": "static-1.508",
  "calling-global-api": "static-1.64327",
  "calling-internal-common": "static-1.31253",
  "calling-lifecycle-internal": "static-1.65709",
  "calling-lifecycle-messages": "static-1.58003",
  "commerce-products-lib": "static-1.9333",
  "conditional-properties-service-client": "static-1.3756",
  "crm-links": "static-1.6233",
  "external-options-client-types": "static-1.4118",
  "google-libphonenumber": "static-1.37",
  "inbounddb-objects-service-types": "static-1.4183",
  "meetings-icalendar-utils-lib": "static-1.583",
  "multi-currency-client-types": "static-1.3651",
  "object-builder-ui-client": "static-1.48559",
  "pipeline-validation-client-types": "static-1.3925",
  "smart-property-lib": "static-1.6674",
  "tiered-pricing": "static-1.1099",
  "ui-addon-form-validation": "static-1.10940",
  "crm-pipelines-api-client-types": "static-1.4102",
  "ui-addon-opt": "static-4.8325",
  "campaign-roi-lib": "static-1.8926",
  "react-dnd-compat": "static-1.4572",
  "react-immutable-render-mixin": "static-1.9",
  "growth-data-modal": "static-1.5348",
  "growth-onboarding-confetti": "static-1.3019",
  "growth-onboarding-next-action-utils": "static-1.1760",
  "onboarding-tours-utils": "static-1.568",
  "ui-shepherd-tracker": "static-1.7481",
  "academy-service-client": "static-1.3634",
  "croppie": "static-2.10",
  "FileManagerCore": "static-1.38970",
  "FileManagerLib": "static-1.39111",
  "video-embed": "static-1.35589",
  "zustand": "static-1.72",
  "ui-coaching-tips": "static-1.28397",
  "redux-actions": "static-3.7",
  "video-components-external": "static-1.11097",
  "video-data-lib": "static-1.34755",
  "emoji-mart": "static-3.4",
  "knowledge-content-types": "static-1.8479",
  "payment-link-components": "static-1.23384",
  "ui-addon-emoji-picker": "static-1.9839",
  "EmailSignatureEditor": "static-1.24261",
  "viral-links-lib": "static-1.7004",
  "data-token-picker": "static-1.16315",
  "react-flip-move": "static-1.69",
  "nested-table": "static-1.177",
  "timezone-utils": "static-2.5196",
  "getting-started-shared-tasks-store": "static-1.17466",
  "diff-match-patch": "static-1.7",
  "browser-eslint": "static-2.57",
  "customer-data-associations": "static-1.7277",
  "customer-data-views-management": "static-1.25353",
  "framework-data-table": "static-2.11801",
  "marketing-platform-lib": "static-1.6803",
  "nudge-client-utils": "static-1.2447",
  "nudge-custom-ui-functions": "static-1.936",
  "app-users-service-client": "static-1.5543",
  "app-users-service-types": "static-1.4951",
  "mini-checkout-client": "static-1.26674",
  "onboarding-utils": "static-1.5303",
  "permissions-shared-i18n-strings-fe": "static-1.2039",
  "ui-coaching-tips-shared-config": "static-1.28382",
  "edison-service-client-types": "static-1.338",
  "crm_data": "static-4.91788",
  "customer-data-sidebar": "static-2.45851",
  "enrichment-properties-lib": "static-1.15792",
  "commerce-billing-lib": "static-1.18912",
  "commerce-shared-components-lib": "static-1.18371",
  "commerce-tools-ui-lib": "static-1.10232",
  "crm-fe-perf": "static-1.22855",
  "bend-plugin-pulse": "static-1.11",
  "directed-graph": "static-1.887",
  "event-emitter": "static-1.900",
  "fast-json-patch": "static-1.62",
  "calling-error-reporting": "static-1.31259",
  "shared-worker-versioning": "static-1.10989",
  "calling-usage-tracker": "static-1.6494",
  "voice-sms-access-library": "static-1.775",
  "commerce-permissions": "static-1.717",
  "products-iframe-lib": "static-1.7774",
  "products-ui-components-shared-msw-handlers": "static-1.10225",
  "data-agent-kit": "static-1.114",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.9926",
  "policy-lib": "static-1.6724",
  "react-tinymce": "static-1.55092",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.9989",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.54218",
  "tinymce-plugins": "static-1.57332",
  "tinymce-themes": "static-1.56188",
  "onboarding-data-sync-lib": "static-1.1878",
  "growth-onboarding-next-action-components": "static-1.1788",
  "user-context-client": "static-1.4562",
  "audio-components": "static-1.5840",
  "cropperjs": "static-1.10",
  "FileManagerImages": "static-1.36622",
  "urlinator": "static-1.4483",
  "video-components": "static-1.13100",
  "outpost": "static-1.4141",
  "growth-onboarding-feedback-components": "static-1.6535",
  "content-media-composition-data-lib": "static-1.12075",
  "content-media-compositions": "static-2.16082",
  "media-bridge-lib": "static-1.18838",
  "commerce-tours-lib": "static-1.5999",
  "growth-onboarding-reliability": "static-1.5033",
  "sales-checkout-service-client": "static-1.3591",
  "draft-convert": "static-2.72",
  "draft-extend": "static-3.74",
  "draft-js": "static-5.77",
  "draft-plugins": "static-2.21581",
  "sales-email-signature-service-client": "static-1.3795",
  "ts-utils-lib": "static-1.125",
  "crm-export-dialog": "static-1.6250",
  "crm-index-associations-lib": "static-1.6390",
  "react-beautiful-dnd": "static-1.13",
  "deal-intel-decorators": "static-1.1827",
  "tanstack-virtual": "static-1.29",
  "nudge-custom-function-registry": "static-1.2204",
  "nudge-renderer-utils": "static-1.2523",
  "whisper-core-api": "static-1.6456",
  "InboxConnectUtils": "static-4.14653",
  "emoji-regex": "static-1.7",
  "touchless-buying-components": "static-1.5386",
  "settings-content-modals": "static-1.45926",
  "crm_universal": "static-1.21918",
  "customer-data-email": "static-1.17944",
  "card-payment-highlight-lib": "static-1.37014",
  "card-subscription-highlight-lib": "static-1.39370",
  "commerce-contract-lib": "static-1.11857",
  "invoices-highlight-card-lib": "static-1.54536",
  "orders-highlight-card-lib": "static-1.21313",
  "products-highlight-card-lib": "static-1.17617",
  "quotes-highlight-card-lib": "static-1.71799",
  "crm-source-interpretation-lib": "static-1.5290",
  "utility-belt": "static-1.2489",
  "payments-enrollment-embed-lib": "static-1.22528",
  "stripe-embedded-components": "static-1.7412",
  "customer-data-rte": "static-1.32856",
  "cv-backend-services": "static-1.1551",
  "growth-onboarding-empty-states": "static-1.5622",
  "payments-post-enroll-local-storage-lib": "static-1.5061",
  "qrcode-generator": "static-1.68",
  "quotes-client-types": "static-1.37889",
  "calling-orchestration-schema": "static-1.35552",
  "sales-views-client-types": "static-1.4216",
  "hub-http-contrib": "static-1.2992",
  "interframe": "static-3.4713",
  "tinymce-data": "static-1.40303",
  "ui-addon-sales-email": "static-1.5162",
  "layout-dnd-components": "static-1.12346",
  "layout-dnd-utils": "static-1.11321",
  "ui-brand-identity-lib": "static-1.15006",
  "NamespacedHubStyle": "static-2.9022",
  "social-insights-client-types": "static-1.21939",
  "js-cookie": "static-1.18",
  "deal-intel-utils": "static-1.1831",
  "checkout-sdk": "static-3.23517",
  "checkout-service-types": "static-1.3786",
  "company-details-components": "static-1.6148",
  "payment-method-components": "static-1.6864",
  "pricing-pages-ui-components": "static-1.13616",
  "quote-checkout-service-types": "static-1.3432",
  "upgrade-catalog-service-types": "static-1.3476",
  "access-control-lib": "static-1.10389",
  "EmailComponents": "static-1.54620",
  "EmailData": "static-1.53297",
  "redux-less": "static-2.9435",
  "sequences-lib": "static-1.7952",
  "ui-gdpr-components": "static-1.10299",
  "products-ui-components": "static-1.39852",
  "accounting-integrations-ui-components": "static-1.6979",
  "invoices-ui-lib": "static-1.54552",
  "commerce-products-api": "static-1.2211",
  "invoices-iframe-lib": "static-1.56610",
  "quotes-modal-lib": "static-1.102477",
  "quotes-ui-lib": "static-1.80520",
  "stripe-connect-js": "static-1.67",
  "draft-content-plugins": "static-1.28124",
  "ContentData": "static-1.68285",
  "layout-data-lib": "static-1.9646",
  "hub-http-rxjs": "static-1.793",
  "normalizr": "static-3.9",
  "ramda": "static-1.7",
  "company-details-service-types": "static-1.3884",
  "billing-payments-client-types": "static-1.3942",
  "react-performance-metrics-lib": "static-1.510",
  "account-and-billing-fintech-outages": "static-3.18496",
  "pricing-pages-api": "static-1.13481",
  "ContentComponents": "static-2.71166",
  "marketing-contacts-lib": "static-1.9782",
  "marketing-email-service-types": "static-1.1886",
  "messaging-editing-lib": "static-1.46109",
  "messaging-usage-based-billing-components-lib": "static-1.971",
  "automation-ui-source-apps": "static-1.18713",
  "automation-ui-types": "static-1.19631",
  "messaging-types-lib": "static-1.45846",
  "onboarding-settings-client": "static-1.4454",
  "sequences-client-types-lib": "static-1.7809",
  "commerce-tax-lib": "static-1.475",
  "price-books-api": "static-1.448",
  "price-books-components": "static-1.506",
  "property-description-translator": "static-1.3799",
  "commerce-analytics-service-client": "static-1.3579",
  "totals-ui-components": "static-1.23434",
  "SalesContentIndexUI": "static-3.9166",
  "advanced-menus-core": "static-1.15048",
  "advanced-menus-lib": "static-1.12000",
  "ui-memberships-settings-lib": "static-1.33902",
  "segments-query-core": "static-1.1366",
  "demographics-service-types": "static-1.1604",
  "eligibility-engine-service-types": "static-1.3136",
  "automation-ui-ubb": "static-1.5547",
  "blueimp-md5": "static-1.8",
  "content-embed-lib": "static-1.7291",
  "data-token-views": "static-1.16296",
  "forms-utils-lib": "static-1.12482",
  "payments-embed-points-lib": "static-1.12923",
  "simple-menus-core": "static-1.15047",
  "simple-menus-lib": "static-1.16564",
  "ui-addon-draggable-compat": "static-2.4206",
  "videoconference-integration-components": "static-1.6744",
  "marketing-contacts-client": "static-1.7470",
  "automation-applications-service-types": "static-1.3459",
  "automation-platform-service-types": "static-1.2565",
  "ContentEditorUI": "static-2.76967",
  "short-messages-app-service-client": "static-1.3933",
  "web-interactives-components": "static-1.13672",
  "web-interactives-data": "static-1.13673",
  "messaging-shared-utils-lib": "static-1.420",
  "messaging-user-info-utils-lib": "static-1.590",
  "email-portal-health-service-types": "static-1.928",
  "line-items-api": "static-1.612",
  "commerce-totals-service-types": "static-1.3778",
  "FireAlarmUi": "static-1.4473",
  "sales-templates-service-types-lib": "static-1.4127",
  "seamless-immutable": "static-7.6",
  "automation-ui-core": "static-2.21567",
  "automation-ui-usage-tracking": "static-1.21030",
  "data-studio-ubb": "static-1.2561",
  "backbone": "static-1.6",
  "campaigns-lib": "static-1.26877",
  "collaboration-sidebar": "static-1.57637",
  "content-management-data-lib": "static-1.5318",
  "copilot-plugins": "static-1.10951",
  "cta-picker": "static-1.36262",
  "customer-agent-discovery-components-lib": "static-1.2929",
  "editor-components": "static-1.13160",
  "editor-iframe-lib": "static-1.8332",
  "error-messaging-js": "static-1.5143",
  "FormsCommonComponents": "static-1.85691",
  "pictos": "static-7.183",
  "react-transition-group": "static-2.64",
  "redux-request-state": "static-1.10598",
  "SharedLegalStrings": "static-1.1699",
  "smart-content-core": "static-1.42290",
  "smart-content-lib": "static-1.42943",
  "social-composer-lib": "static-1.58869",
  "structured-content-lib": "static-1.25048",
  "theme-previewer-lib": "static-1.53107",
  "tinymce-copilot": "static-1.16286",
  "xray-recommendation-lib": "static-1.7830",
  "automation-ui-routing": "static-1.20988",
  "sql-reporting-client-types": "static-1.5591",
  "jquery": "static-3.6",
  "attribution-lib": "static-1.42055",
  "campaigns-utils-lib": "static-1.3120",
  "reporting-enablement": "static-1.22722",
  "chatspot-widget-iframe": "static-1.21031",
  "collaboration-sidebar-common": "static-1.2434",
  "forms-ai-lib": "static-1.4238",
  "codemirror-dlb": "static-1.58526",
  "redux-mock-store": "static-1.8",
  "redux-undo": "static-1.10",
  "seo-tools-lib": "static-1.6381",
  "report-customization-components": "static-1.13016",
  "data-quality-ui-library": "static-1.12762",
  "html-to-image": "static-1.53",
  "reporting-filters": "static-1.180",
  "reporting-insights-lib": "static-1.1576"
},
  depPathPrefixes: {
  "marketplace-storefront-public-ui": "/marketplace-storefront-public-ui/static-1.12077",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "client-types": "/client-types/static-1.460",
  "dashboard-client-types": "/dashboard-client-types/static-1.345",
  "data-fetching-client": "/data-fetching-client/static-1.9626",
  "foundations-components": "/foundations-components/static-1.7834",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.859",
  "foundations-theming": "/foundations-theming/static-1.4368",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "graphql": "/graphql/static-1.81",
  "head-dlb": "/head-dlb/static-1.4938",
  "hs-test-utils": "/hs-test-utils/static-1.7968",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9843",
  "hubspot-dlb": "/hubspot-dlb/static-2.1832",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4049",
  "HubStyleTokens": "/HubStyleTokens/static-2.11414",
  "I18n": "/I18n/static-7.1611",
  "jasmine-runner": "/jasmine-runner/static-1.6421",
  "marketplace-storefront-base": "/marketplace-storefront-base/static-1.12138",
  "quartz": "/quartz/static-1.6958",
  "react-dlb": "/react-dlb/static-1.78",
  "react-rhumb": "/react-rhumb/static-1.16618",
  "reactive-variable-buffer-atom": "/reactive-variable-buffer-atom/static-1.2811",
  "reporting-testing-lib": "/reporting-testing-lib/static-1-jbartola_hubspot-replace-checked-ts.32",
  "settings-ui-lib": "/settings-ui-lib/static-1.12473",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "signup-ui-core": "/signup-ui-core/static-1.10391",
  "source-map": "/source-map/static-1.4",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.7039",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11102",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9497",
  "unified-auth": "/unified-auth/static-1.428",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.709",
  "usage-tracker": "/usage-tracker/static-1.7290",
  "usage-tracker-core": "/usage-tracker-core/static-1.7140",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8035",
  "hub-http": "/hub-http/static-1.6173",
  "integrations-lib": "/integrations-lib/static-1.15951",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.19517",
  "property-management-iframe": "/property-management-iframe/static-1.12981",
  "quartz-config": "/quartz-config/static-1.736",
  "quartz-core": "/quartz-core/static-1.6177",
  "quartz-routing": "/quartz-routing/static-1.388",
  "quick-fetch": "/quick-fetch/static-1.3876",
  "react": "/react/static-7.185",
  "rpc-client-utils": "/rpc-client-utils/static-1.4602",
  "ts-schema": "/ts-schema/static-1.4037",
  "ui-universal-auth": "/ui-universal-auth/static-1.8914",
  "UIComponents": "/UIComponents/static-3.8361",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.84",
  "enviro": "/enviro/static-4.428",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5489",
  "PortalIdParser": "/PortalIdParser/static-2.388",
  "raven": "/raven/static-3.5829",
  "raven-hubspot": "/raven-hubspot/static-1.6136",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.77",
  "metrics-js": "/metrics-js/static-1.9542",
  "react-redux": "/react-redux/static-7.70",
  "redux": "/redux/static-4.16",
  "styled-components": "/styled-components/static-2.88",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3363",
  "moment": "/moment/static-3.26",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3235",
  "quartz-webpack": "/quartz-webpack/static-1.3182",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.36",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4103",
  "floating-ui": "/floating-ui/static-1.55",
  "foundations-assets": "/foundations-assets/static-1.4808",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2084",
  "framer-motion": "/framer-motion/static-1.71",
  "hs-story-utils": "/hs-story-utils/static-1.9380",
  "react-aria": "/react-aria/static-1.65",
  "react-create-root-preference": "/react-create-root-preference/static-1.10",
  "react-select-plus": "/react-select-plus/static-1.104",
  "react-utils": "/react-utils/static-2.5303",
  "react-virtualized": "/react-virtualized/static-2.98",
  "StyleGuideUI": "/StyleGuideUI/static-3.486",
  "tanstack-table": "/tanstack-table/static-1.54",
  "trellis-assets": "/trellis-assets/static-1.1678",
  "ui-fonts": "/ui-fonts/static-1.676",
  "ui-images": "/ui-images/static-2.1140",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2851",
  "foundations-theming-base": "/foundations-theming-base/static-1.3353",
  "stylex": "/stylex/static-1.32",
  "HeadJS": "/HeadJS/static-2.741",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3079",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.151",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.220",
  "moment-timezone": "/moment-timezone/static-5.82",
  "jasmine": "/jasmine/static-4.4276",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.8802",
  "ai-rendering-library": "/ai-rendering-library/static-1.9916",
  "chirp-fetch": "/chirp-fetch/static-1.1837",
  "connections-embed-lib": "/connections-embed-lib/static-1.903",
  "copilot-toolkit": "/copilot-toolkit/static-1.10978",
  "feedback-loader": "/feedback-loader/static-1.29204",
  "laboratory-lib": "/laboratory-lib/static-3.7110",
  "marketplace-embed": "/marketplace-embed/static-1.21920",
  "marketplace-ui-details": "/marketplace-ui-details/static-1.9413",
  "marketplace-ui-reviews": "/marketplace-ui-reviews/static-1.19473",
  "marketplace-ui-tracking": "/marketplace-ui-tracking/static-1.13688",
  "sanitize-text": "/sanitize-text/static-1.8095",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8650",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.5704",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4976",
  "wootric-nps": "/wootric-nps/static-1.6937",
  "quartz-head": "/quartz-head/static-1.623",
  "web-vitals": "/web-vitals/static-1.4",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4600",
  "immer": "/immer/static-1.33",
  "immerable": "/immerable/static-1.4105",
  "highcharts": "/highcharts/static-8.103",
  "hs-lodash": "/hs-lodash/static-4.45",
  "reporting-client-types": "/reporting-client-types/static-1.2466",
  "reporting-data": "/reporting-data/static-1-jbartola_hubspot-replace-checked-ts.32",
  "cssUtils": "/cssUtils/static-1.779",
  "flux-actions": "/flux-actions/static-1.331",
  "HubStyle": "/HubStyle/static-2.11722",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "react-colorpicker": "/react-colorpicker/static-2.10162",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10323",
  "rxjs": "/rxjs/static-5.10",
  "underscore": "/underscore/static-1.8",
  "usage-tracker-container": "/usage-tracker-container/static-1.7280",
  "icons": "/icons/static-2.644",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.18050",
  "storybook-react": "/storybook-react/static-1.32",
  "trellis-story-utils": "/trellis-story-utils/static-1.4467",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5317",
  "quartz-i18n": "/quartz-i18n/static-1.633",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.82",
  "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.194",
  "fsm": "/fsm/static-1.3684",
  "customer-data-objects": "/customer-data-objects/static-1.7614",
  "property-translator": "/property-translator/static-1.5354",
  "hs-locale-management": "/hs-locale-management/static-1.43",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7879",
  "hs-promise-utils": "/hs-promise-utils/static-1.5545",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4828",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13366",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5550",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7735",
  "reselect": "/reselect/static-2.16",
  "sanitize": "/sanitize/static-1.4424",
  "superstore": "/superstore/static-1.4718",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10100",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.7804",
  "hub-http-janus": "/hub-http-janus/static-1.827",
  "hubspotter-http": "/hubspotter-http/static-1.4611",
  "immutable-less": "/immutable-less/static-1.4601",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.16924",
  "nav-meta": "/nav-meta/static-1.29488",
  "react-window": "/react-window/static-1.13",
  "self-service-api": "/self-service-api/static-1.10197",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.17913",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3800",
  "property-management-common": "/property-management-common/static-1.5269",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9006",
  "dispatcher": "/dispatcher/static-1.135",
  "general-store": "/general-store/static-6.20",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.515",
  "module-federation": "/module-federation/static-1.22",
  "quartz-auth": "/quartz-auth/static-1.633",
  "quartz-test": "/quartz-test/static-1.633",
  "quartz-tracking": "/quartz-tracking/static-1.337",
  "history": "/history/static-4.47",
  "react-router-dom": "/react-router-dom/static-5.26",
  "csstype": "/csstype/static-1.50",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.12",
  "bender-build-tools": "/bender-build-tools/static-1.3123",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3550",
  "persist-promise": "/persist-promise/static-1.3659",
  "reference-resolvers": "/reference-resolvers/static-1.8122",
  "transmute": "/transmute/static-2.85",
  "autolinker": "/autolinker/static-3.11",
  "chatspot-core": "/chatspot-core/static-1.21040",
  "ContentUtils": "/ContentUtils/static-1.68210",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.12977",
  "sassPrefix": "/sassPrefix/static-1.155",
  "avatar-components": "/avatar-components/static-1.2450",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.39567",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13111",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.14164",
  "ExportDialog": "/ExportDialog/static-6.10345",
  "highlight.js": "/highlight.js/static-1.78",
  "markdown-it": "/markdown-it/static-1.6",
  "reporting-action-components": "/reporting-action-components/static-1.41158",
  "reporting-snowflake": "/reporting-snowflake/static-1-jbartola_hubspot-replace-checked-ts.32",
  "reporting-ui-components": "/reporting-ui-components/static-2-jbartola_hubspot-replace-checked-ts.32",
  "reporting-visualizations": "/reporting-visualizations/static-1-jbartola_hubspot-replace-checked-ts.32",
  "ui-addon-teams": "/ui-addon-teams/static-1.21479",
  "magpie-lib": "/magpie-lib/static-1.5528",
  "navigation-components": "/navigation-components/static-1.17851",
  "magpie-types": "/magpie-types/static-1.4988",
  "simple-logging-lib": "/simple-logging-lib/static-1.3001",
  "ai-studio-lib": "/ai-studio-lib/static-1.11445",
  "app-governance-lib": "/app-governance-lib/static-1.1375",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10461",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.7947",
  "ui-product-approvals": "/ui-product-approvals/static-1.27990",
  "ui-tool-access": "/ui-tool-access/static-1.10101",
  "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.8617",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5707",
  "usage-tracker-public": "/usage-tracker-public/static-1.7101",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.59",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.3881",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.287",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2964",
  "final-form": "/final-form/static-1.69",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "simple-data-table": "/simple-data-table/static-1.2625",
  "merchandise-lib": "/merchandise-lib/static-1.262",
  "atom": "/atom/static-1.5024",
  "purchase-motions-components": "/purchase-motions-components/static-1.5791",
  "salesImages": "/salesImages/static-1.524",
  "batch-promise": "/batch-promise/static-1.1502",
  "crm-component-utils": "/crm-component-utils/static-1.38938",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.5828",
  "customer-data-properties": "/customer-data-properties/static-1.51366",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6830",
  "property-value-citations": "/property-value-citations/static-1.1980",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8046",
  "navigation-messaging": "/navigation-messaging/static-1.7178",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9841",
  "growth-payments-core": "/growth-payments-core/static-1.25213",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.13517",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7200",
  "crm-message-bus": "/crm-message-bus/static-1.42844",
  "reporting-plugins": "/reporting-plugins/static-1.10207",
  "reporting-reports": "/reporting-reports/static-1-jbartola_hubspot-replace-checked-ts.32",
  "cms-field-types": "/cms-field-types/static-1.4763",
  "content-icons-ui": "/content-icons-ui/static-1.2213",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9778",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.22002",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4671",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3969",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6735",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.931",
  "onboarding-tours": "/onboarding-tours/static-1.16502",
  "academy-common-lib": "/academy-common-lib/static-1.13624",
  "content-assistance-lib": "/content-assistance-lib/static-1.7675",
  "dashboard-lib": "/dashboard-lib/static-1.81313",
  "file-manager-components": "/file-manager-components/static-1.23471",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.18348",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.18085",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.18077",
  "prosemirror": "/prosemirror/static-1.13",
  "rich-text-lib": "/rich-text-lib/static-1.19742",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8649",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4721",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.10957",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9000",
  "user-context": "/user-context/static-1.5053",
  "idb-keyval": "/idb-keyval/static-1.43",
  "reactive-lib": "/reactive-lib/static-1.673",
  "nest": "/nest/static-1.179",
  "codemirror": "/codemirror/static-5.94",
  "react-codemirror": "/react-codemirror/static-1.10575",
  "framework-listing-lib": "/framework-listing-lib/static-2.28531",
  "fuzzy": "/fuzzy/static-1.8",
  "user-configuration-lib": "/user-configuration-lib/static-1.30577",
  "apps-service-types": "/apps-service-types/static-1.3829",
  "oauth-service-types": "/oauth-service-types/static-1.4201",
  "onboarding-scopes": "/onboarding-scopes/static-1.6414",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4716",
  "platform-infra-nav-components": "/platform-infra-nav-components/static-1.7632",
  "subscription-experience-data-types": "/subscription-experience-data-types/static-1.14842",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3570",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9089",
  "redux-thunk": "/redux-thunk/static-2.43",
  "purchase-motions-api": "/purchase-motions-api/static-1.5794",
  "signup-constants": "/signup-constants/static-1.18746",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.7990",
  "trials-service-types": "/trials-service-types/static-1.3855",
  "card-properties-lib": "/card-properties-lib/static-1.44016",
  "commerce-subscription-lib": "/commerce-subscription-lib/static-1.36947",
  "crm-actions": "/crm-actions/static-1.6270",
  "crm-cards-sdk": "/crm-cards-sdk/static-1.43424",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9170",
  "customer-data-tracking": "/customer-data-tracking/static-1.6837",
  "hs-resources": "/hs-resources/static-1.96",
  "pulse": "/pulse/static-1.508",
  "calling-global-api": "/calling-global-api/static-1.64327",
  "calling-internal-common": "/calling-internal-common/static-1.31253",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.65709",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.58003",
  "commerce-products-lib": "/commerce-products-lib/static-1.9333",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3756",
  "crm-links": "/crm-links/static-1.6233",
  "external-options-client-types": "/external-options-client-types/static-1.4118",
  "google-libphonenumber": "/google-libphonenumber/static-1.37",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4183",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.583",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3651",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.48559",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3925",
  "smart-property-lib": "/smart-property-lib/static-1.6674",
  "tiered-pricing": "/tiered-pricing/static-1.1099",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10940",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4102",
  "ui-addon-opt": "/ui-addon-opt/static-4.8325",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.8926",
  "react-dnd-compat": "/react-dnd-compat/static-1.4572",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "growth-data-modal": "/growth-data-modal/static-1.5348",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3019",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1760",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.568",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7481",
  "academy-service-client": "/academy-service-client/static-1.3634",
  "croppie": "/croppie/static-2.10",
  "FileManagerCore": "/FileManagerCore/static-1.38970",
  "FileManagerLib": "/FileManagerLib/static-1.39111",
  "video-embed": "/video-embed/static-1.35589",
  "zustand": "/zustand/static-1.72",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28397",
  "redux-actions": "/redux-actions/static-3.7",
  "video-components-external": "/video-components-external/static-1.11097",
  "video-data-lib": "/video-data-lib/static-1.34755",
  "emoji-mart": "/emoji-mart/static-3.4",
  "knowledge-content-types": "/knowledge-content-types/static-1.8479",
  "payment-link-components": "/payment-link-components/static-1.23384",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9839",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.24261",
  "viral-links-lib": "/viral-links-lib/static-1.7004",
  "data-token-picker": "/data-token-picker/static-1.16315",
  "react-flip-move": "/react-flip-move/static-1.69",
  "nested-table": "/nested-table/static-1.177",
  "timezone-utils": "/timezone-utils/static-2.5196",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17466",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "browser-eslint": "/browser-eslint/static-2.57",
  "customer-data-associations": "/customer-data-associations/static-1.7277",
  "customer-data-views-management": "/customer-data-views-management/static-1.25353",
  "framework-data-table": "/framework-data-table/static-2.11801",
  "marketing-platform-lib": "/marketing-platform-lib/static-1.6803",
  "nudge-client-utils": "/nudge-client-utils/static-1.2447",
  "nudge-custom-ui-functions": "/nudge-custom-ui-functions/static-1.936",
  "app-users-service-client": "/app-users-service-client/static-1.5543",
  "app-users-service-types": "/app-users-service-types/static-1.4951",
  "mini-checkout-client": "/mini-checkout-client/static-1.26674",
  "onboarding-utils": "/onboarding-utils/static-1.5303",
  "permissions-shared-i18n-strings-fe": "/permissions-shared-i18n-strings-fe/static-1.2039",
  "ui-coaching-tips-shared-config": "/ui-coaching-tips-shared-config/static-1.28382",
  "edison-service-client-types": "/edison-service-client-types/static-1.338",
  "crm_data": "/crm_data/static-4.91788",
  "customer-data-sidebar": "/customer-data-sidebar/static-2.45851",
  "enrichment-properties-lib": "/enrichment-properties-lib/static-1.15792",
  "commerce-billing-lib": "/commerce-billing-lib/static-1.18912",
  "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.18371",
  "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.10232",
  "crm-fe-perf": "/crm-fe-perf/static-1.22855",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.11",
  "directed-graph": "/directed-graph/static-1.887",
  "event-emitter": "/event-emitter/static-1.900",
  "fast-json-patch": "/fast-json-patch/static-1.62",
  "calling-error-reporting": "/calling-error-reporting/static-1.31259",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.10989",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6494",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.775",
  "commerce-permissions": "/commerce-permissions/static-1.717",
  "products-iframe-lib": "/products-iframe-lib/static-1.7774",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10225",
  "data-agent-kit": "/data-agent-kit/static-1.114",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.9926",
  "policy-lib": "/policy-lib/static-1.6724",
  "react-tinymce": "/react-tinymce/static-1.55092",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.9989",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.54218",
  "tinymce-plugins": "/tinymce-plugins/static-1.57332",
  "tinymce-themes": "/tinymce-themes/static-1.56188",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.1878",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.1788",
  "user-context-client": "/user-context-client/static-1.4562",
  "audio-components": "/audio-components/static-1.5840",
  "cropperjs": "/cropperjs/static-1.10",
  "FileManagerImages": "/FileManagerImages/static-1.36622",
  "urlinator": "/urlinator/static-1.4483",
  "video-components": "/video-components/static-1.13100",
  "outpost": "/outpost/static-1.4141",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6535",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.12075",
  "content-media-compositions": "/content-media-compositions/static-2.16082",
  "media-bridge-lib": "/media-bridge-lib/static-1.18838",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.5999",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5033",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3591",
  "draft-convert": "/draft-convert/static-2.72",
  "draft-extend": "/draft-extend/static-3.74",
  "draft-js": "/draft-js/static-5.77",
  "draft-plugins": "/draft-plugins/static-2.21581",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3795",
  "ts-utils-lib": "/ts-utils-lib/static-1.125",
  "crm-export-dialog": "/crm-export-dialog/static-1.6250",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6390",
  "react-beautiful-dnd": "/react-beautiful-dnd/static-1.13",
  "deal-intel-decorators": "/deal-intel-decorators/static-1.1827",
  "tanstack-virtual": "/tanstack-virtual/static-1.29",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.2204",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.2523",
  "whisper-core-api": "/whisper-core-api/static-1.6456",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.14653",
  "emoji-regex": "/emoji-regex/static-1.7",
  "touchless-buying-components": "/touchless-buying-components/static-1.5386",
  "settings-content-modals": "/settings-content-modals/static-1.45926",
  "crm_universal": "/crm_universal/static-1.21918",
  "customer-data-email": "/customer-data-email/static-1.17944",
  "card-payment-highlight-lib": "/card-payment-highlight-lib/static-1.37014",
  "card-subscription-highlight-lib": "/card-subscription-highlight-lib/static-1.39370",
  "commerce-contract-lib": "/commerce-contract-lib/static-1.11857",
  "invoices-highlight-card-lib": "/invoices-highlight-card-lib/static-1.54536",
  "orders-highlight-card-lib": "/orders-highlight-card-lib/static-1.21313",
  "products-highlight-card-lib": "/products-highlight-card-lib/static-1.17617",
  "quotes-highlight-card-lib": "/quotes-highlight-card-lib/static-1.71799",
  "crm-source-interpretation-lib": "/crm-source-interpretation-lib/static-1.5290",
  "utility-belt": "/utility-belt/static-1.2489",
  "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.22528",
  "stripe-embedded-components": "/stripe-embedded-components/static-1.7412",
  "customer-data-rte": "/customer-data-rte/static-1.32856",
  "cv-backend-services": "/cv-backend-services/static-1.1551",
  "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.5622",
  "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.5061",
  "qrcode-generator": "/qrcode-generator/static-1.68",
  "quotes-client-types": "/quotes-client-types/static-1.37889",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.35552",
  "sales-views-client-types": "/sales-views-client-types/static-1.4216",
  "hub-http-contrib": "/hub-http-contrib/static-1.2992",
  "interframe": "/interframe/static-3.4713",
  "tinymce-data": "/tinymce-data/static-1.40303",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5162",
  "layout-dnd-components": "/layout-dnd-components/static-1.12346",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11321",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.15006",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9022",
  "social-insights-client-types": "/social-insights-client-types/static-1.21939",
  "js-cookie": "/js-cookie/static-1.18",
  "deal-intel-utils": "/deal-intel-utils/static-1.1831",
  "checkout-sdk": "/checkout-sdk/static-3.23517",
  "checkout-service-types": "/checkout-service-types/static-1.3786",
  "company-details-components": "/company-details-components/static-1.6148",
  "payment-method-components": "/payment-method-components/static-1.6864",
  "pricing-pages-ui-components": "/pricing-pages-ui-components/static-1.13616",
  "quote-checkout-service-types": "/quote-checkout-service-types/static-1.3432",
  "upgrade-catalog-service-types": "/upgrade-catalog-service-types/static-1.3476",
  "access-control-lib": "/access-control-lib/static-1.10389",
  "EmailComponents": "/EmailComponents/static-1.54620",
  "EmailData": "/EmailData/static-1.53297",
  "redux-less": "/redux-less/static-2.9435",
  "sequences-lib": "/sequences-lib/static-1.7952",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10299",
  "products-ui-components": "/products-ui-components/static-1.39852",
  "accounting-integrations-ui-components": "/accounting-integrations-ui-components/static-1.6979",
  "invoices-ui-lib": "/invoices-ui-lib/static-1.54552",
  "commerce-products-api": "/commerce-products-api/static-1.2211",
  "invoices-iframe-lib": "/invoices-iframe-lib/static-1.56610",
  "quotes-modal-lib": "/quotes-modal-lib/static-1.102477",
  "quotes-ui-lib": "/quotes-ui-lib/static-1.80520",
  "stripe-connect-js": "/stripe-connect-js/static-1.67",
  "draft-content-plugins": "/draft-content-plugins/static-1.28124",
  "ContentData": "/ContentData/static-1.68285",
  "layout-data-lib": "/layout-data-lib/static-1.9646",
  "hub-http-rxjs": "/hub-http-rxjs/static-1.793",
  "normalizr": "/normalizr/static-3.9",
  "ramda": "/ramda/static-1.7",
  "company-details-service-types": "/company-details-service-types/static-1.3884",
  "billing-payments-client-types": "/billing-payments-client-types/static-1.3942",
  "react-performance-metrics-lib": "/react-performance-metrics-lib/static-1.510",
  "account-and-billing-fintech-outages": "/account-and-billing-fintech-outages/static-3.18496",
  "pricing-pages-api": "/pricing-pages-api/static-1.13481",
  "ContentComponents": "/ContentComponents/static-2.71166",
  "marketing-contacts-lib": "/marketing-contacts-lib/static-1.9782",
  "marketing-email-service-types": "/marketing-email-service-types/static-1.1886",
  "messaging-editing-lib": "/messaging-editing-lib/static-1.46109",
  "messaging-usage-based-billing-components-lib": "/messaging-usage-based-billing-components-lib/static-1.971",
  "automation-ui-source-apps": "/automation-ui-source-apps/static-1.18713",
  "automation-ui-types": "/automation-ui-types/static-1.19631",
  "messaging-types-lib": "/messaging-types-lib/static-1.45846",
  "onboarding-settings-client": "/onboarding-settings-client/static-1.4454",
  "sequences-client-types-lib": "/sequences-client-types-lib/static-1.7809",
  "commerce-tax-lib": "/commerce-tax-lib/static-1.475",
  "price-books-api": "/price-books-api/static-1.448",
  "price-books-components": "/price-books-components/static-1.506",
  "property-description-translator": "/property-description-translator/static-1.3799",
  "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3579",
  "totals-ui-components": "/totals-ui-components/static-1.23434",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.9166",
  "advanced-menus-core": "/advanced-menus-core/static-1.15048",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12000",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.33902",
  "segments-query-core": "/segments-query-core/static-1.1366",
  "demographics-service-types": "/demographics-service-types/static-1.1604",
  "eligibility-engine-service-types": "/eligibility-engine-service-types/static-1.3136",
  "automation-ui-ubb": "/automation-ui-ubb/static-1.5547",
  "blueimp-md5": "/blueimp-md5/static-1.8",
  "content-embed-lib": "/content-embed-lib/static-1.7291",
  "data-token-views": "/data-token-views/static-1.16296",
  "forms-utils-lib": "/forms-utils-lib/static-1.12482",
  "payments-embed-points-lib": "/payments-embed-points-lib/static-1.12923",
  "simple-menus-core": "/simple-menus-core/static-1.15047",
  "simple-menus-lib": "/simple-menus-lib/static-1.16564",
  "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.4206",
  "videoconference-integration-components": "/videoconference-integration-components/static-1.6744",
  "marketing-contacts-client": "/marketing-contacts-client/static-1.7470",
  "automation-applications-service-types": "/automation-applications-service-types/static-1.3459",
  "automation-platform-service-types": "/automation-platform-service-types/static-1.2565",
  "ContentEditorUI": "/ContentEditorUI/static-2.76967",
  "short-messages-app-service-client": "/short-messages-app-service-client/static-1.3933",
  "web-interactives-components": "/web-interactives-components/static-1.13672",
  "web-interactives-data": "/web-interactives-data/static-1.13673",
  "messaging-shared-utils-lib": "/messaging-shared-utils-lib/static-1.420",
  "messaging-user-info-utils-lib": "/messaging-user-info-utils-lib/static-1.590",
  "email-portal-health-service-types": "/email-portal-health-service-types/static-1.928",
  "line-items-api": "/line-items-api/static-1.612",
  "commerce-totals-service-types": "/commerce-totals-service-types/static-1.3778",
  "FireAlarmUi": "/FireAlarmUi/static-1.4473",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.4127",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "automation-ui-core": "/automation-ui-core/static-2.21567",
  "automation-ui-usage-tracking": "/automation-ui-usage-tracking/static-1.21030",
  "data-studio-ubb": "/data-studio-ubb/static-1.2561",
  "backbone": "/backbone/static-1.6",
  "campaigns-lib": "/campaigns-lib/static-1.26877",
  "collaboration-sidebar": "/collaboration-sidebar/static-1.57637",
  "content-management-data-lib": "/content-management-data-lib/static-1.5318",
  "copilot-plugins": "/copilot-plugins/static-1.10951",
  "cta-picker": "/cta-picker/static-1.36262",
  "customer-agent-discovery-components-lib": "/customer-agent-discovery-components-lib/static-1.2929",
  "editor-components": "/editor-components/static-1.13160",
  "editor-iframe-lib": "/editor-iframe-lib/static-1.8332",
  "error-messaging-js": "/error-messaging-js/static-1.5143",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.85691",
  "pictos": "/pictos/static-7.183",
  "react-transition-group": "/react-transition-group/static-2.64",
  "redux-request-state": "/redux-request-state/static-1.10598",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.1699",
  "smart-content-core": "/smart-content-core/static-1.42290",
  "smart-content-lib": "/smart-content-lib/static-1.42943",
  "social-composer-lib": "/social-composer-lib/static-1.58869",
  "structured-content-lib": "/structured-content-lib/static-1.25048",
  "theme-previewer-lib": "/theme-previewer-lib/static-1.53107",
  "tinymce-copilot": "/tinymce-copilot/static-1.16286",
  "xray-recommendation-lib": "/xray-recommendation-lib/static-1.7830",
  "automation-ui-routing": "/automation-ui-routing/static-1.20988",
  "sql-reporting-client-types": "/sql-reporting-client-types/static-1.5591",
  "jquery": "/jquery/static-3.6",
  "attribution-lib": "/attribution-lib/static-1.42055",
  "campaigns-utils-lib": "/campaigns-utils-lib/static-1.3120",
  "reporting-enablement": "/reporting-enablement/static-1.22722",
  "chatspot-widget-iframe": "/chatspot-widget-iframe/static-1.21031",
  "collaboration-sidebar-common": "/collaboration-sidebar-common/static-1.2434",
  "forms-ai-lib": "/forms-ai-lib/static-1.4238",
  "codemirror-dlb": "/codemirror-dlb/static-1.58526",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-undo": "/redux-undo/static-1.10",
  "seo-tools-lib": "/seo-tools-lib/static-1.6381",
  "report-customization-components": "/report-customization-components/static-1.13016",
  "data-quality-ui-library": "/data-quality-ui-library/static-1.12762",
  "html-to-image": "/html-to-image/static-1.53",
  "reporting-filters": "/reporting-filters/static-1.180",
  "reporting-insights-lib": "/reporting-insights-lib/static-1.1576"
}
};
